module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"traffic:title":"Пробки","traffic:time-now":"Сейчас"},"en":{"traffic:title":"Traffic","traffic:time-now":"Now"}}')
  delete Component.options._Ctor
}
